export default "__VITE_ASSET__B8uX$2ei__"